import ParallelActions from '../utils/ParallelActions';
import SequencedActions from '../utils/SequencedActions';

export default class WinController {
	constructor(scene, linesController, useScatter, scatter, winShowTime) {
		this.scene = scene;
		this.linesController = linesController;
		this.scatter = scatter;
		this.useScatter = useScatter && scatter !== null;
		this.winShowTime = winShowTime;
		this.payTable = this.scene.payTableFull;
		this.scatterPayTable = this.scene.scatterPayTable;
		this.reels = this.scene.reels;
		this.scatterWin = null;
		this.winLines = [];
		this.scatterWinSymbols = [];
		this.winSeq = null;
	}

	// Return true if slot has any winning
	hasAnyWinn() {
		var hasLineWin = this.winLines.length > 0;
		var hasScatterWin = this.scatterWin !== null;
		return hasLineWin || hasScatterWin;
	}

	searchWinSymbols() {
		console.log('search win symbols');
		this.winLines = [];
		this.linesController.lines.forEach(lB => {
			if (lB.isSelected) {
				lB.findWin(this.payTable);
				if (lB.win != null) {
					this.winLines.push(lB);
					console.log(lB.number + ' - line win: ' + lB.win);
				}
			}
		});

		// search scatters
		this.scatterWinSymbols = [];

		this.scatterWin = null;

		if (this.useScatter) {
			this.reels.forEach(reel => {
				var temp = reel.findWindowsSymbols(this.scatter);
				if (temp.length > 0) scatterWinSymbols.push(...temp);
			});

			this.scatterPayTable.forEach(sPL => {
				if (sPL.scattersCount > 0 && sPL.scattersCount == this.scatterWinSymbols.length) {
					this.scatterWin = new WinData(this.scatterWinSymbols, sPL.freeSpins, sPL.pay);
				}
			});
		}
		if (this.scatterWin == null) this.scatterWinSymbols = [];
	}

	hasScatterWin() {
		return this.scatterWin != null;
	}

	winSymbolShowOnce(completeCallBack) {
		if (this.winSeq != null) this.winSeq.break();
		this.winSeq = new SequencedActions();

		//show linewins - all paylines at the same time
		var pA = new ParallelActions();
		this.winLines.forEach(l => {
			pA.add(callBack => {
				l.lineFlashing(true);
				l.setLineVisible(true);

				l.lineWinPlay(
					this.winShowTime, // lineWinPlay time (symbols animation time)
					win => {
						l.lineFlashing(false);
						l.setLineVisible(false);
						callBack();
					}
				);
			});
		});

		this.winSeq.add(callBack => {
			pA.start(() => {
				callBack();
			});
		});

		//show scatterwin
		if (this.useScatter && this.scatterWinSymbols != null && this.scatterWinSymbols.length > 0) {
			var pAs = new ParallelActions();
			this.scatterWinSymbols.forEach(() => {
				pAs.add(callBack => {
					item.showWinPrefab();
					new SimpleTweenFloat(this, 0, 1, 3000, callBack); // just delay action
				});
			});

			this.winSeq.add(callBack => {
				pAs.start(() => {
					callBack();
				});
			});
		}

		this.winSeq.add(callBack => {
			completeCallBack();
			callBack();
		});

		this.winSeq.start();
	}

	winShowCancel() {
		if (this.winSeq !== null) {
			this.winSeq.break();
		}

		if (this.winLines !== null) {
			this.winLines.forEach(lb => {
				lb.lineWinCancel();
			});
		}

		if (this.scatterWinSymbols !== null) {
			this.scatterWinSymbols.forEach(s => {
				s.showAnim(false);
			});
		}
		console.log('winShowCancel');
	}

	resetWin() {
		this.winLines.forEach(l => {
			l.resetLineWinning();
		});
		this.scatterWinSymbols = null;
		this.scatterWin = null;
	}

	getLineWinCoins() {
		let res = 0;
		this.winLines.forEach(l => {
			res += l.win.pay;
		});
		return res;
	}

	getScatterWinCoins() {
		if (this.scatterWin !== null) return this.scatterWin.pay;
		return 0;
	}

	getWinSpins() {
		let res = 0;
		this.winLines.forEach(l => {
			res += l.win.freeSpins;
		});
		if (this.scatterWin !== null) res += this.scatterWin.freeSpins;
		return res;
	}
}
